import { bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceGenDocToIRBCancellationQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue: bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowClass = new bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowClass();
}